import gql from 'graphql-tag';

const cancelledPurchaseQuery = gql`
  query cancelledPurchaseQuery($id: ID!) {
    cancelledPurchase(id: $id) {
      id
      buyerEmail
      cancellingUserName
      auctionAccessNo
      dealerNo
      vin
      universalNo
      guaranteeDaysSelected
      guaranteeMilesSelected
      guaranteeIfBid
      guaranteeSellerPaid
      automaticPurchase
      vehiclePurchasePrice
      guaranteePrice
      inspectionPrice
      cancellationDate
      cancellationReason
      guaranteeOffer {
        guaranteeStatus
      }
    }
  }
`;

export default cancelledPurchaseQuery;
